function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSpotifyWhite = function SvgSpotifyWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.03 48.03"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0a24 24 0 1 0 24 24A24 24 0 0 0 24 0Zm11 34.68a1.59 1.59 0 0 1-2.16.54c-9.46-5.69-20.67-2.4-20.78-2.37a1.58 1.58 0 0 1-.92-3c.51-.15 12.64-3.75 23.32 2.68a1.58 1.58 0 0 1 .54 2.15ZM38 28a1.87 1.87 0 0 1-1.62.93 1.92 1.92 0 0 1-.93-.24 31.59 31.59 0 0 0-24-2.82 1.86 1.86 0 1 1-1.21-3.52 35 35 0 0 1 27 3.1A1.88 1.88 0 0 1 38 28Zm1.33-6.42a2.17 2.17 0 0 1-1.07-.26c-13.69-7.19-27.76-2.89-27.9-2.84A2.3 2.3 0 1 1 9 14.13c.65-.2 16.05-4.91 31.42 3.16a2.29 2.29 0 0 1-1.07 4.32Z",
    style: {
      fill: "#fff"
    },
    "data-name": "Layer 1"
  })));
};

export default SvgSpotifyWhite;